import Vue from 'vue'
import App from './App.vue'

// Router
import VueRouter from 'vue-router'
import routes from '@/routes/routes'
Vue.use(VueRouter)
const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
// Store
import store from "@/store/store"
// i18n
import { i18n } from "@/plugins/i18n"
// Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import '@/globalComponents.js'

import '@/styles/main.scss'

Vue.config.productionTip = false

window.mainApp = new Vue({
  render: h => h(App),
  router,
  store,
  i18n
}).$mount('#app')